import dayjs from 'dayjs';
import CurrencyRateService from '../services/currency-rates.service';
import { Currency, CurrencyRate } from './models/models';

export default {
  namespaced: true,
  state: {
    currencyRateId: null,
    ratesRequestDate: dayjs().format('MMMM YYYY'),
    totalCurrencyRates: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
  },
  mutations: {
    currencyRateId(state, currencyRateId) {
      state.currencyRateId = currencyRateId;
    },
    totalCurrencyRates(state, totalCurrencyRates) {
      state.totalCurrencyRates = totalCurrencyRates;
    },
    ratesRequestDate(state, ratesRequestDate) {
      state.ratesRequestDate = ratesRequestDate;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getCurrencies');
    },
    newCurrencyRate({ commit }) {
      CurrencyRate.new()
        .then((category) => {
          commit('currencyRateId', category.id);
        });
    },
    updateCurrencyRateProps({ state }, props) {
      CurrencyRate.update({
        where: state.currencyRateId,
        data: props,
      });
    },
    getCurrencies() {
      return CurrencyRateService.getCurrencies()
        .then((res) => {
          Currency.create({ data: res });
        });
    },
    parseCurrencies({ state }) {
      const date = dayjs(state.ratesRequestDate).format('YYYY-MM-DD HH:mm:ss');
      return CurrencyRateService.parseCurrencies({ date: date })
        .then((res) => {
          if (res.hasOwnProperty('currencies')) {
            CurrencyRate.create({ data: res.currencies.data, insertOrUpdate: ['currencies'] });
          }
          return res;
        });
    },
    getCurrencyRates({ commit, state }) {
      return CurrencyRateService.getCurrencyRates(state.query)
        .then((res) => {
          commit('totalCurrencyRates', res.total);
          CurrencyRate.create({ data: res.data, insertOrUpdate: ['currencies'] });
        });
    },
    suggestCurrencyRates(store, query) {
      return CurrencyRateService.suggestCurrencyRates(query);
    },
    getCurrencyRate({ commit }, id) {
      return CurrencyRateService.getCurrencyRate(id)
        .then((currencyRate) => {
          CurrencyRate.insert({ data: [currencyRate] })
            .then(() => {
              commit('currencyRateId', currencyRate.id);
            });
        });
    },
    createCurrencyRate({ getters }) {
      return CurrencyRateService.createCurrencyRate(getters.currencyRate);
    },
    updateCurrencyRate({ getters, dispatch }) {
      return CurrencyRateService.updateCurrencyRate(getters.currencyRate)
        .then((res) => {
          if (res.hasOwnProperty('currency_rate_id')) {
            dispatch('getCurrencyRate', res.currency_rate_id);
          }
          return res;
        });
    },
    deleteCurrencyRate({ getters }) {
      return CurrencyRateService.deleteCurrencyRate(getters.currencyRate)
        .then((res) => {
          if (res.hasOwnProperty('currency_rate_id')) {
            CurrencyRate.delete(res.currency_rate_id);
          }
          return res;
        });
    },
  },
  getters: {
    currencies() {
      return Currency.all();
    },
    currencyRates() {
      return CurrencyRate.all();
    },
    currencyRate(state) {
      if (!state.currencyRateId) {
        return null;
      }
      return CurrencyRate
        .query()
        .with(['currency_from', 'currency_to'])
        .find(state.currencyRateId);
    },
  },
};
